import * as React from 'react';
import { ISelectListItem } from './ISelectListItem';
import { Icon } from 'sos-common/js/components/Icon/icon';

export interface ISiteFunctionsProps {
  siteMapUrl: string;
  minorityLanguages: ISelectListItem[];
  translatedItems: ISelectListItem[];
  translatedStartPageItems: ISelectListItem[];
}

export interface ISiteFunctionsState {
  isOpen: boolean;
}

/**
 * Renders, if available; sitemap button, other languages button.
 */
export class SiteFunctions extends React.Component<ISiteFunctionsProps, ISiteFunctionsState> {
  constructor(props: ISiteFunctionsProps) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  toggleOpen = (): void => {
    this.setState((prev) => ({
      isOpen: !prev.isOpen,
    }));
  };

  render() {
    return (
      <div className={`site-menu__functions ${this.state.isOpen ? 'open' : ''}`}>
        <div className="site-menu__functions-header">
          {this.props.siteMapUrl && (
            <a href={this.props.siteMapUrl} className="site-menu__function-item">
              <Icon iconType="Webbkarta" />
              <span className="functionlink__text">Webbkarta</span>
            </a>
          )}
          {(this.props.minorityLanguages.length > 0 ||
            this.props.translatedItems.length > 0 ||
            this.props.translatedStartPageItems.length > 0) && (
            <button
              className={`site-menu__function-item functionlink ${this.state.isOpen ? 'open' : ''}`}
              type="button"
              onClick={this.toggleOpen}>
              <Icon iconType="fontawesome/globe-europe" />
              <span className="functionlink__text">Language</span>
            </button>
          )}
        </div>

        <ul className="site-menu__language-expander">
          {(this.props.translatedItems || []).map((lang) => (
            <li key={lang.Value}>
              <a href={lang.Value}>Go to {lang.Text}</a>
            </li>
          ))}

          {(this.props.translatedStartPageItems || []).map((lang) => (
            <li key={lang.Value}>
              <a href={lang.Value}>Go to {lang.Text} startpage</a>{' '}
            </li>
          ))}

          {this.props.minorityLanguages.map((lang) => (
            <li key={lang.Value}>
              <a href={lang.Value}>Go to {lang.Text}</a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
